import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import client from "../api/commonApi";
import { Box, Typography, Container } from "@mui/material";
import { v4 } from "uuid";
import { userInfo } from "./AuthProvider";
import { useSetRecoilState, useRecoilValue } from 'recoil';
import { isDebug, utils } from "../utils";
import LanguageSelector from "./LanguageSelector";


const LoginPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [code, setCode] = useState({});
  const [limit, setLimit] = useState(180);

  //recoil 사용 선언부
  const setUserInfo = useSetRecoilState(userInfo);
  const auth = useRecoilValue(userInfo);
  if (isDebug()) console.log("## auth", new Date().toISOString(), auth);

  useEffect(() => {
    if (isDebug()) console.log("pathname", pathname);

    // 임시 Access Token을 sessionStorage에 설정
    // sessionStorage.setItem(
    //   "access",
    //   "eyJ0eXAiOiAiSldUIiwgImFsZyI6ICJFZERTQSIsICJraWQiOiAiZGlkOnNvdjpQNXo0d3NHY0IzTkFDak5HUTZLUTdYI2tleS0xIn0.eyJfc2QiOiBbInZEUGU1Y19HVzNpeGtPQndGZkcxQ2dqVzhra2x3SXpMSmprcUtlN1h4MGMiXSwgImlzcyI6ICJodHRwczovL3Utc3RjLm5ldCIsICJpYXQiOiAxNzMxODk0OTYxLCAiZXhwIjogMTczMTk4MTM2MSwgIm1lbWJlcklkIjogIjI1NDk0OGNhLTFkMDgtNDk4Ni1hODNhLWVmMTA5ZDRhYjcxMyIsICJtZW1iZXJOYW1lIjogImxvZ2luX3Rlc3RfMjAiLCAibWVtYmVyVHlwZSI6IG51bGwsICJjb21wYW55TmFtZSI6ICJcdWQ1MGNcdWI3YWJcdWQzZmMiLCAiX3NkX2FsZyI6ICJzaGEtMjU2In0.D0Sc6AGgov9VcoVqBuAZPw48WR-fAoeHq0_Ot_trW1NmURWWVP3_DkIfmq62kFjBlLwNXJ5gVmg3Ia5tNSbPBg~WyJOcnBaOEVjZHhzb0xpakhETkNaMWdnIiwgImRpZCIsICJkaWQ6c292OlVFTE5tRVF2dTNwR3J1RVRXOHJEaFMiXQ~",
    // );

    // Access Token 디코드 및 출력 (테스트 목적)
    const accessToken = sessionStorage.getItem("access");
    const decodedPayload = utils.api.decodeJWT(accessToken);
    if (isDebug()) console.log("Decoded JWT Payload:", new Date().toISOString(), decodedPayload);
  }, [pathname]);
  //

  useEffect(() => {
    if (limit === 0) {
      /*// navigate("/");*/
      navigate(0);
      // return;
    }
  }, [limit, navigate]);

  useEffect(() => {
    const pulling_key = v4().toString();
    const c = {
      // type: "login",
      type: "user/login",
      data: {
        pulling_key: pulling_key,
        subscription_id: "",
      },
    };

    setCode(c);

    const limitInterval = setInterval(() => {
      setLimit((time) => time - 1);
    }, 3000);

    const interval = setInterval(() => {
      /*// let location = useLocation();*/
      const accessToken = sessionStorage.getItem("access");

      if (isDebug()) console.log("pathname", pathname);
      // location.pathname: 현재 페이지의 경로 URL

      client
        .create({ timeout: 3000 })
        .get("/member/login", {
          headers: {
            PullingKey: pulling_key,
          },
        })
        .then((response) => {
          // 201 때 token 받음
          if (response.status === 201) {
            clearInterval(interval);

            sessionStorage.setItem("access",response.headers.access);
            sessionStorage.setItem("refresh",response.headers.refresh);
            sessionStorage.setItem("fp",response.headers.fp);
            /*// console.log("## connection_id:", response.headers.connection_id);*/
            if (isDebug()) console.log("## JWT access:", accessToken);

            // JWT 페이로드 디코드 후 콘솔 출력
            const decodedPayload = utils.api.decodeJWT(response.headers.access);
            try{
              if(decodedPayload !== null) {
                if (isDebug()) console.log("Decoded JWT Payload:", new Date().toISOString(), decodedPayload);
                if (isDebug()) console.log("## JWT memberId:", new Date().toISOString(), decodedPayload.memberId);
                if (isDebug()) console.log("## JWT memberName:", new Date().toISOString(), decodedPayload.memberName);
                if (isDebug()) console.log("## JWT memberType:", new Date().toISOString(), decodedPayload.memberType);
                setUserInfo({
                  userId: decodedPayload.memberId,
                  userName: decodedPayload.memberName,
                  userType: decodedPayload.memberType,
                });
              }
            }
            catch(error){
              console.error("Error decoding JWT:", error);
            }
            /*
            // console.log("## JWT access:", decodedPayload.access);
            // console.log("## JWT refresh:", decodedPayload.refresh);
            // console.log("## JWT fp:", decodedPayload.fp);
            */

            // 메인화면으로 이동하기
            if (pathname === "/login") {
              navigate("/");
            } 
            // else {
            //   window.location.reload();
            // }
          }
        })
        .catch((reason) => {
          console.log(reason);
        });
    }, 3000);

    return () => {
      clearInterval(limitInterval);
      clearInterval(interval);
    };
  }, []);

  return (
      <Box
        sx={{
          pb: 6,
          m: 0,
          p: 0,

          height: "100%",
          display: "flex",
          alignItems: "center",
        }}
        className="LoginPage"
      >
        <Container sx={{ p: 10, }} maxWidth="lg" >
          <Box>
            <Typography
              component="h2"
              variant="h5"
              sx={{ fontWeight: "600", textAlign: "center" }}
              gutterBottom
            >
              {t("header.title")}
              <Typography component="h2" variant="h4" sx={{ fontWeight: "800", m: 2 }}>
                {t("header.login")}
              </Typography>
            </Typography>
          </Box>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              margin: "20px 0 10%",
            }}
          >
            <div
              style={{
                height: "auto",
                margin: "0 auto",
                maxWidth: 300,
                maxHeight: 300,
                width: "100%",
                border: "1px solid #efefef",
                borderRadius: 10,
                padding: 50,
                backgroundColor: "#fff",
              }}>

              <div
                style={{
                  height: "auto",
                  margin: "0 auto",
                  maxWidth: 256,
                  width: "100%",
                }}>

                <QRCode
                  size={256}
                  style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                  value={JSON.stringify(code)}
                  viewBox={`0 0 256 256`}
                />
                
              </div>
            
            </div>
          </Box>
          <LanguageSelector />
          {'▶ ' + t('others.timeleft')} : {`${limit} ${t('times.second')}`}
        </Container>
      </Box>
  );
};
export default LoginPage;
